<label class="form-check form-check-inline form-check-solid me-5">
  <input class="form-check-input" name="{{name}}" type="checkbox" [(ngModel)]="checked" (ngModelChange)="onModelChange($event)" />
  <span class="fw-bold ps-2 fs-6">{{displayName}}</span>
</label>
